import React, { useState, useEffect } from 'react'
import NegoziTable from './Negozi/NegoziTable';
import { Tabs } from 'antd';
import ArticleTable from './Articoli/ArticleTable';
import axios from 'axios';


const { TabPane } = Tabs;

function callback(key) {
    console.log(key);
}

export default function AnalyticsTabs() {

    const [negozio, setNegozio] = useState('');

    function fetchProfile() {
        axios
            .get(`${process.env.REACT_APP_SERVER_URL}/api/user/me`)
            .then((response) => {
                console.log(response);
                setNegozio(response.data.username)
            }).catch((error) => {
                console.log('hey there')
                // console.log(error)
            });
    }


    useEffect(() => {
        fetchProfile()
    }, []);

    if(negozio) {
    return (<Tabs defaultActiveKey="1" centered onChange={callback}>
        <TabPane tab="Negozi" key="1">
            <NegoziTable negozio={negozio} />
        </TabPane>
        <TabPane tab="Articoli" key="2">
            <ArticleTable />
        </TabPane>
        {/* <TabPane tab="Clienti" key="3">
            Tab clienti ancora da fare
    </TabPane> */}
    </Tabs>
    );
    } else {
        return <p>sto caricando...</p>
    }



}
